import {DOIT_CONFIG, TENANT} from '@/config/config_api_backend'
import http from '../plugins/http'
import axios from 'axios'
import {getLocalStorageObject, putLocalStorageObject} from '@/helpers/LocalStorageHelper'


const apiGetConfigDocumentScore = async () => {
    try {
        let response = await http.get(DOIT_CONFIG.GET_DOCUMENT_CONFIG)
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}


const getTenantConfig = async () => {
    try {
        // Get Data from service
        let obj = getLocalStorageObject('tenant_config')
        let resFixed = obj
        // Check tenant_config exist
        if (obj == null || obj.latestRequest == null) {
            let res = await axios.get(TENANT.GET_CONFIG)

            if (res != null) {
                let data = res.data
                resFixed = {...data, 'latestRequest': (new Date).getTime()}
                putLocalStorageObject("tenant_config", resFixed)
            }
        } else {
            if ((new Date().getTime() - obj.latestRequest > 300000)) {
                let res = await axios.get(TENANT.GET_CONFIG)
                if (res != null) {
                    let data = res.data
                    resFixed = {...data, 'latestRequest': (new Date).getTime()}
                    putLocalStorageObject("tenant_config", resFixed)
                }
            }
        }
        return resFixed

    } catch (e) {
        console.log(e)
        return null
    }
}
export {apiGetConfigDocumentScore, getTenantConfig}
